import { Box, Button, IconProps, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { MiddleProps } from "./type"
import { useTranslation } from "react-i18next"
import ActionCard from "../../components/actionCard"
import { icons } from "../../../../../../utils/icons"
import { Fragment, useMemo } from "react"
import { ModelThree } from "../../../../../reportFolio/pages/dashboard/components/details"
import dayjs from "dayjs"
import { Constants } from "../../../../../../utils/constants"
import { NoResponse } from "../../../../../../components/errors/noResponse"
import { ActionPlanAnswer } from "../../../../../../service/actionPlans/actionPlanById"
import { Status } from "../../../../../../utils/enums"

function Middle({ answerActionPlan, approveUsers, status, canReassign, openReassign, openDetail }: MiddleProps) {
    const { t } = useTranslation()
    const styles = useStyles()
    const answerLenght = answerActionPlan?.length
    const totalList = [...approveUsers ?? []]
    const showReassignButton = useMemo(() => {
        return !!(!!totalList?.length && status && ![Status.REJECTED, Status.APPROVED, Status.EXPIRED].includes(status)) && canReassign

    }, [totalList?.length, canReassign])
    const clickActionPlan = ({ actionPlan }: { actionPlan: ActionPlanAnswer }) => {
        openDetail({ actionPlan: actionPlan })
    }

    return (
        <Box sx={styles.container({ reassignButton: !!showReassignButton, areThereApprovers: !!totalList?.length })}>
            <Box className="container">
                <Typography color='primary.100' variant="subtitle" fontWeight='bold'>{t('actionPlan.actionPlanResponse')}</Typography>

                <Box className="scroll_container">
                    {
                        !!answerLenght && answerActionPlan?.map((actionPlan, index) => (
                            <ActionCard
                                active={index == 0}
                                hover
                                key={actionPlan.id}
                                onClick={() => { clickActionPlan({ actionPlan }) }}
                                icon={{ position: 'start', icon: <ActionCard.Icon<IconProps> color='primary_company' icon={icons('person')} /> }}
                            >
                                <ActionCard.Header label={t('actionPlan.emitBy')} />

                                <ActionCard.Title label={`${actionPlan?.userResponse?.firstName ?? ''} ${actionPlan?.userResponse?.lastName ?? ''}`.trim()} />

                                <ActionCard.Footer label={dayjs(actionPlan.create_time).locale('es').format(Constants.dayjsHumanFormat)} />
                            </ActionCard>
                        ))
                    }

                    {
                        !answerLenght && <NoResponse label={t('actionPlan.noActionPlan')} />
                    }
                </Box>
            </Box>

            {!!showReassignButton && (<Button onClick={openReassign} variant="dark_c_nr">{t('actionPlan.reassignActionPlan')}</Button>)}

            {
                (!!totalList?.length) &&
                <Box className="container">

                    <Typography color='primary.100' variant="subtitle" fontWeight='bold'>{t('actionPlan.aprovers')}</Typography>

                    <Box className="scroll_container">
                        {totalList?.map((item, index) => (
                            <Fragment key={index}>
                                <ModelThree title={item.label} description={item.email ?? ''} date={''} />
                            </Fragment>
                        ))
                        }

                        {
                            !totalList?.length && <NoResponse label={t('actionPlan.noAprovers')} />
                        }
                    </Box>
                </Box>
            }
        </Box>
    )
}

export default Middle